import React from "react";
import {shallowEqual, useSelector} from "react-redux";
import {State} from "../../../redux/store";

export const useAuthStore = () => {
  return useSelector((state: State) => state.auth, shallowEqual);
};
